// extracted by mini-css-extract-plugin
export default {"actions":"Modificaciones_actions__Vp5LB","download":"Modificaciones_download__akQW8","mes":"Modificaciones_mes__Y84+N","modificacion":"Modificaciones_modificacion__e2Nf9"};